var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXdb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.974 2h2.55l.005 8.722a.32.32 0 0 1 0 .05 5.73 5.73 0 1 1-2.556-4.779V2zM7.032 13.4a3.17 3.17 0 1 0 3.522-5.272 3.17 3.17 0 0 0-3.522 5.27zm13.754 16.6H18.23v-8.772a5.732 5.732 0 1 1 2.556 4.779V30zm4.935-11.388a3.168 3.168 0 1 0-3.52 5.268 3.168 3.168 0 0 0 3.52-5.268zM21.042 3.517h-.05a5.73 5.73 0 1 0 4.778 2.555h3.994V3.517h-8.72zm-.05 2.562a3.17 3.17 0 1 1 0 6.336 3.17 3.17 0 0 1 0-6.337zm-9.224 22.403H3v-2.556h3.987a5.73 5.73 0 1 1 4.78 2.556zm-1.762-3.096a3.168 3.168 0 0 0 1.76.534h.002a3.17 3.17 0 1 0-1.762-.533z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXdb);
export default __webpack_public_path__ + "static/media/XDB.85f34ca15893062c4ccabd64b8e9fe6b.svg";
export { ForwardRef as ReactComponent };